<template>
    <!-- Checkbox -->
    <template v-if="type === 'checkbox'">
        <div class="form-group__checkboxes">
            <label v-for="(option, index) in options"
                   :key="option.ID"
                   class="form-group__checkbox">
                <input type="checkbox"
                       class="form-control field-instance-input"
                       :data-instance-key="instance.key"
                       :data-field-type="instance.field.type"
                       :name="`fields-${instance.key}[${index}]`"
                       :value="option.ID"
                       :checked="instance.value.indexOf(option.ID) !== -1"
                       :required="instance.field.required" />
                {{ option.name }}
                <FieldOptionPrice :price="option.price" />
            </label>
        </div>
    </template>

    <!-- Date of Birth -->
    <template v-else-if="type === 'dateofbirth'">
        <!-- Note there is no two-way binding for the value. It gets left in the DOM element. -->
        <DateOfBirthInput :instance="instance" />
    </template>

    <!-- Radios -->
    <template v-else-if="type === 'radiobutton'">
        <div class="form-group__checkboxes">
            <label v-for="option in options"
                   :key="option.ID"
                   class="form-group__checkbox">
                <input type="radio"
                       class="form-control field-instance-input"
                       :data-instance-key="instance.key"
                       :data-field-type="instance.field.type"
                       :name="`fields-${instance.key}`"
                       :value="option.ID"
                       :checked="instance.value === option.ID"
                       :required="instance.field.required" />
                {{ option.name }}
                <FieldOptionPrice :price="option.price" />
            </label>
        </div>
    </template>

    <!-- Select -->
    <template v-else-if="type === 'select'">
        <select class="field-instance-input form-control input-lg"
                :data-instance-key="instance.key"
                :data-field-type="instance.field.type"
                :name="`fields-${instance.key}`"
                :required="instance.field.required">
            <option value="">
                {{ l('FIELDS.SELECT_PLACEHOLDER') }}
            </option>
            <option v-for="option in options"
                    :key="option.ID"
                    :selected="instance.value === option.ID"
                    :value="option.ID">
                {{ option.name }}
                {{ option.priceStringForSelectLabel }}
            </option>
        </select>
    </template>

    <!-- Textarea -->
    <template v-else-if="type === 'textarea'">
        <textarea class="field-instance-input form-control input-lg"
                  :data-instance-key="instance.key"
                  :data-field-type="instance.field.type"
                  :name="`fields-${instance.key}`"
                  :required="instance.field.required">{{ instance.value }}</textarea>
    </template>

    <!-- Textbox -->
    <template v-else-if="type === 'textbox'">
        <input type="text"
               class="field-instance-input form-control input-lg"
               :data-instance-key="instance.key"
               :data-field-type="instance.field.type"
               :name="`fields-${instance.key}`"
               :required="instance.field.required"
               :value="instance.value" />
    </template>
</template>

<script>
import DateOfBirthInput from '@/vue/components/CustomFields/DateOfBirthInput';
import FieldOptionPrice from '@/vue/components/CustomFields/FieldOptionPrice';
import { sortByNavOrder } from '@/functions/arraySorting';

export default {
    components: {
        DateOfBirthInput,
        FieldOptionPrice,
    },

    props: {
        /**
         * @type {FieldInstance}
         */
        instance: {
            type: Object,
            required: true,
        },
    },

    computed: {
        /**
         * @returns {String}
         */
        type() {
            return this.instance.field.type;
        },

        /**
         * @returns {FieldOption[]|null}
         */
        options() {
            if (!this.instance.field.hasOptions) {
                return null;
            }

            const options = this.instance.field.options;
            sortByNavOrder(options);

            return options;
        },
    },
};
</script>
